import Loading from '@@/core/components/shared/Loading/Loading'
import StoreModal from '@@/core/components/store/StoreForm/StoreForm'
import mixins from '@@/core/mixins/mixins'
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, BFormCheckbox, VBToggle} from "bootstrap-vue";

export default {
  name: "Store",
  components: {
    Loading,
    StoreModal,
    BTooltip, BButton, BCard, BTable, BCollapse, BFormGroup, BFormCheckbox, BFormInput
  },
  directives: {
    'b-toggle': VBToggle
  },
  mixins: [mixins],
  data() {
    return {
      url: `admin/stores/transactions`,
      id: this.$route.params.id,
      mode: 'increment',
      items: [],
      stores: [],
      selectedStore: null,
      fields: [{
        key: 'id',
        label: 'شناسه'
      },
        {
          key: 'store_name',
          label: 'نام انبار'
        },
        {
          key: 'admin_name',
          label: 'کاربر'
        },
        {
          key: 'product',
          label: 'محصول'
        },
        {
          key: 'description',
          label: 'توضیح'
        },
        {
          key: 'quantity',
          label: 'تعداد'
        },
        {
          key: 'type',
          label: 'نوع تغییرات'
        },
        {
          key: 'created_at',
          label: 'تاریخ ثبت'
        },
      ],
      store: {
        selectedProduct: null,
        selectedVariety: null
      },
      typeOptions: [{
        value: 'increment',
        title: 'افزایش'
      },
        {
          value: 'decrement',
          title: 'کاهش'
        },
        {
          value: '',
          title: 'همه'
        },
      ],
      filter: {
        product_id: '',
        variety_id: '',
        isHidden: 0,
        type: '',
        start_date: null,
        end_date: null
      }
    }
  },
  mounted() {
    this.loadStoreItems();
    this.loadStores();
    this.filter.start_date = null;  
    this.filter.end_date =null;  
  },
  watch: {
    'filter.type': function (newVal) {
      if (typeof newVal === 'string' || typeof newVal === 'number') {
        this.filter.type = this.typeOptions.find(item => {
          return item.value == newVal
        })
      }
    },
    "$route.query": function(newValue) {
      this.loadItems();
    },
  },
  computed: {  
    pageCount() {  
        return this.items.last_page;
    }  
  },  
  methods: {
    print() {
      window.print();  
    },
    handleDataSubmitted(data) {
      this.items = data;
    }, 
    resetFilters() {
      this.selectedStore = null;  
      this.filter.type.value = '';  
      this.filter.type.title = 'همه';  
      this.filter.type = '';  
      this.filter.start_date = '';  
      this.filter.end_date = '';  
      this.filter.product_id = '';  
      this.filter.variety_id = '';  

      this.loadStoreItems();
    },  
    async loadStores(){
        try {
            const response = await this.$axios.get("admin/stores");
            this.stores = response.data.data.stores;
        } catch (e) {
            this.$root.notify(e);
        } 
    },
    doFilter() {
      if (this.selectedStore) {
        this.loadStoreItems();
      }else{
        this.$root.notify(
          "انبار را انتخاب کنید.",
          "warning"
        );
        return;
      }
    },
    changePage(page) {  
      this.$router.replace({  
        path: this.$route.path,  
        query: { ...this.$route.query, page: page },  
      }).then(() => {  
        this.loadStoreItems();
      });  
    },  
    async loadStoreItems() {  
        try {  
            let page = this.$route.query.page || 1;
            const response = await this.$axios.get("admin/stores/transactions", {  
                params: {  
                    page,  
                    store_id: this.selectedStore ? this.selectedStore.id : '',  
                    is_hidden: this.filter.isHidden,  
                    product_id: this.filter.product_id ? this.filter.product_id : '',  
                    variety_id: this.filter.variety_id ? this.filter.variety_id : '',  
                    type: this.filter.type ? this.filter.type.value : '',  
                    start_date: this.filter.start_date ?? '',  
                    end_date: this.filter.end_date ?? '',  
                },  
            });  
    
            this.items = response.data.data.transactions;  
            this.createRules = response.data.data.store_rules;  
            this.editRules = response.data.data.update_rules;  
        } catch (e) {  
            this.$root.notify(e);  
        }   
    },  
    selectProduct(product) {
      this.filter.product_id = product.id
    },
    selectVariety(variety) {
      this.filter.variety_id = variety.id
    },
    incrementModal() {
      this.store = {
        selectedProduct: null,
        selectedVariety: null,
        store_id: this.store_id,
        quantity: 0,
        varietyQuantity: 0,
        description: ''
      }
      console.log(this.store,this.store_id);
      this.mode = 'increment'
      this.$root.$emit('bv::show::modal', 'store-modal')
    },
    decrementModal() {
      this.store = {
        selectedProduct: null,
        selectedVariety: null,
        store_id: this.store_id,
        quantity: 0,
        varietyQuantity: 0,
        description: ''
      }
      this.mode = 'decrement'
      this.$root.$emit('bv::show::modal', 'store-modal')
    },
  }
}
